import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  
  ButtonGroup,
} from "reactstrap";
 

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
 

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

const SheetPrintForshreenath = props => {
  const [state, setState] = useState({
    id: 0,
    formData: {},
    activeTab: 1,
    memberid: 0,
    success_msg: false,
    JobCard_SheetSizing: [],
    selectedSheet: "sheet1", // Add sheet selection state
  });

  const formTitle = "Sheet Sizing";
  const breadCrumbTitle = "Sheet Sizing";
  const breadCrumbItem = "Print " + formTitle;

   

  useEffect(() => {
    const sheetSizingData = JSON.parse(
      sessionStorage.getItem("SheetSizingData")
    );
    console.log(sheetSizingData);
    if (sheetSizingData) {
      setState(prevState => ({
        ...prevState,
        JobCard_SheetSizing: sheetSizingData.JobCard_SheetSizing,
        SheetSizingData: sheetSizingData.SheetSizingData,
      }));
    }
  }, []);

   

  const handleSheetChange = (sheetType) => {
    setState(prevState => ({
      ...prevState,
      selectedSheet: sheetType,
    }));
  };

  const handlePrint = () => {
    window.print();
  };

  // Sheet 1 Layout Component
  const Sheet1Layout = ({ row, index }) => (
    <div
      key={index}
      className="job-card"
      style={{
        padding: "15px",
        fontFamily: "serif",
        maxWidth: "210mm",
        margin: "0 auto",
        backgroundColor: "white",
        marginTop: index === 0 ? "0" : "20px",
        marginBottom: "15px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        pageBreakInside: "avoid",
        breakInside: "avoid",
      }}
    >
      {/* Main Size */}
      <div
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "14px",
          margin: "20px 0 10px 0",
        }}
      >
        {row.Length} {row.LengthMar} x {row.Width}{" "}
        {row.WidthMar} x {row.Height} {row.HeightMar} 
        
      </div>

      {/* Total */}
      <div
        style={{ textAlign: "center", fontSize: "17px" }}
      >
          ( SheetSizing:{" "}
        <span>{row.LengthX}</span> x{" "}
        <span>{row.HeightX}</span> = {row.ShortQty} Sheets)
      </div>
    </div>
  );

  // Sheet 2 Layout Component
  const Sheet2Layout = ({ row, index }) => (
    <div
      key={index}
      className="job-card"
      style={{
        padding: "15px",
        fontFamily: "serif",
        maxWidth: "210mm",
        margin: "0 auto",
        backgroundColor: "white",
        marginTop: index === 0 ? "0" : "20px",
        marginBottom: "15px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        pageBreakInside: "avoid",
        breakInside: "avoid",
      }}
    >
      <div
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "14px",
          margin: "20px 0 10px 0",
        }}
      >
        ({row.PlyName})   ( SheetSizing:{" "}
        <span>{row.LengthX}</span> x{" "}
        <span>{row.HeightX}</span> = {row.ShortQty} Sheets)
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            .page-content {
              margin: 0 !important;
              padding: 0 !important;
            }
            .container-fluid {
              padding: 0 !important;
              margin: 0 !important;
            }
            .card {
              border: none !important;
              box-shadow: none !important;
            }
            .card-body {
              padding: 0 !important;
            }
            .job-card {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              margin-bottom: 15px !important;
              max-width: 100% !important;
              width: 100% !important;
            }
            .row {
              margin: 0 !important;
            }
            .col {
              padding: 0 !important;
            }
          }
        `}
      </style>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="no-print">
            <Breadcrumbs
              title={breadCrumbTitle}
              breadcrumbItem={breadCrumbItem}
            />

            {/* Sheet Toggle and Print Button */}
            <Row className="mb-3">
              <Col>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                  {/* Sheet Toggle */}
                  <div>
                    <Label style={{ marginRight: "10px", fontWeight: "bold" }}>Select Sheet Layout:</Label>
                    <ButtonGroup>
                      <Button
                        color={state.selectedSheet === "sheet1" ? "primary" : "secondary"}
                        onClick={() => handleSheetChange("sheet1")}
                        style={{ minWidth: "100px" }}
                      >
                        Rotary
                      </Button>
                      <Button
                        color={state.selectedSheet === "sheet2" ? "primary" : "secondary"}
                        onClick={() => handleSheetChange("sheet2")}
                        style={{ minWidth: "100px" }}
                      >
                        Cutting
                      </Button>
                    </ButtonGroup>
                  </div>

                  {/* Print Button */}
                  <Button
                    color="primary"
                    onClick={handlePrint}
                    style={{
                      marginLeft: "20px",
                    }}
                  >
                    <i className="fas fa-print me-2"></i>
                    Print
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <Row className="justify-content-center">
            <Col lg={state.selectedSheet === "sheet1" ? "10" : "8"} md={state.selectedSheet === "sheet1" ? "12" : "10"} sm="12">
              <Card>
                <CardBody>
                  <div className="page-content">
                    {/* Show Ledger name only once at the top */}
                    {state.SheetSizingData && state.SheetSizingData.length > 0 && (
                      <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <h6>{state.SheetSizingData[0].Ledger}</h6>
                      </div>
                    )}
                    
                    {state.SheetSizingData &&
                      state.SheetSizingData.map((row, index) => (
                        state.selectedSheet === "sheet1" ? (
                          <Sheet1Layout key={index} row={row} index={index} />
                        ) : (
                          <Sheet2Layout key={index} row={row} index={index} />
                        )
                      ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default compose(container)(SheetPrintForshreenath);
